<template>
  <KeyRoad />
</template>
<script>
import KeyRoad from '../components/index.vue'

export default {
  name: 'province-road',
  components: {
    KeyRoad,
  },
  provide: {
    pRoadType: 'PROVINCIAL_HIGHWAY',
  },
}
</script>
